/* @flow */

import page from 'page';

import * as Bucket from './modules/bucket';
import * as Catalog from './modules/catalog';
import * as News from './modules/news';
import * as AccountRequests from './modules/user/requests';
import * as AdminEvents from './modules/admin/events';
import * as Campaign from './modules/campaign';
import * as Worker from './modules/workers';

export default function hook() {
  // Bucket
  page('/bucket', Bucket.index);
  page('/bucket/*', Bucket.index);

  // Catalog
  page('/catalog', Catalog.index);
  page('/catalog/*', Catalog.index);

  // News
  page('/news/:id', News.index);

  // Accounts
  page('/accounts/requests', AccountRequests.index);

  // Admin
  page('/admin/events', AdminEvents.index);

  // Campaign
  page('/campaign/:id', Campaign.index);

  page('/customers/:id/workers', Worker.index);

  page.start({
    click: false,
    popstate: false,
  });
}



// WEBPACK FOOTER //
// ./src/router.js